/* eslint-disable no-undef */
import axios from 'axios';
import cookie from 'js-cookie';

import config from 'config';

const api = axios.create({ baseURL: config.apiUrl });

// intercept api request and set the access token for auth
api.interceptors.request.use(
  config => {
    const newConfig = config;
    const authCookie = cookie.get('authentication');

    if (authCookie) {
      const authentication = JSON.parse(authCookie);
      const { access_token, token_type, client, expiry, uid } = authentication;

      // send auth token if it exists
      if (access_token) {
        newConfig.headers['access-token'] = access_token;
        newConfig.headers['token-type'] = token_type;
        newConfig.headers.client = client;
        newConfig.headers.expiry = expiry;
        newConfig.headers.uid = uid;
      }
    }

    return newConfig;
  },
  error => Promise.reject(error)
);

// intercept api responses to check for 401s from auth
api.interceptors.response.use(
  config => config,
  error => {
    const { config } = error;
    if (
      config &&
      error.response &&
      error.response.status === 401 &&
      !error.response.data.errors[0].includes('credentials')
    ) {
      window.location = '/login';
    }
    return Promise.reject(error);
  }
);

export const signIn = data => {
  const { email, password } = data;

  return new Promise((resolve, reject) => {
    getRecaptcha().then(recaptcha => {
      api
        .post('/auth/sign_in', {
          email,
          password,
          recaptcha_token: recaptcha,
        })
        .then(res => {
          const { headers } = res;
          const authentication = {
            access_token: headers['access-token'],
            token_type: headers['token-type'],
            client: headers.client,
            expiry: headers.expiry,
            uid: headers.uid,
          };
          cookie.set('authentication', JSON.stringify(authentication));
          resolve(authentication);
        })
        .catch(err => reject(err));
    });
  });
};

export const logout = () => {
  cookie.remove('authentication');
  window.location = '/login';
};

export const getInvitation = data => {
  const { token } = data;
  return api.get(`/invitation/${token}`);
};

export const acceptInvitation = data => {
  const { invitation_token, password } = data;
  return api.put('/invitation', {
    invitation_token,
    password_confirmation: password,
    password,
  });
};

export const requestPasswordReset = data => {
  const { email } = data;

  return new Promise((resolve, reject) => {
    getRecaptcha().then(recaptcha => {
      api
        .post('/password/reset', {
          email,
          recaptcha_token: recaptcha,
        }).then(res => {
          resolve(res);
        })
        .catch(err => reject(err));
    });
  });
};

export const updatePassword = data => {
  const { password, passwordConfirmation, passwordResetToken } = data;

  return new Promise((resolve, reject) => {
    getRecaptcha().then(recaptcha => {
      api
        .post('/password/update', {
          password,
          password_confirmation: passwordConfirmation,
          password_reset_token: passwordResetToken,
          recaptcha_token: recaptcha,
        }).then(res => {
          resolve(res);
        })
        .catch(err => reject(err));
    });
  });
};

// Helper functions

export const isAuthenticated = () => {
  const authCookie = cookie.get('authentication');
  if (authCookie) {
    const authentication = JSON.parse(authCookie);
    const { access_token } = authentication;
    return access_token ? access_token : false;
  }
};

export const getRecaptcha = () => {
  return new Promise((resolve, reject) => {
    grecaptcha.ready(() => {
      grecaptcha
        .execute('6LenDl4UAAAAAIaT12dwGdDH5hTMBch2W_8i8qtI', {
          action: 'signup',
        })
        .then(token => {
          localStorage.setItem('recaptcha', token);
          resolve(token);
        });
    });
  });
};

export default api;
